import { toast } from 'react-toastify'
import { useCart } from '../../../Providers/CartProvider'
import { useOffers } from '../../../Providers/OffersProvider'
import { useSavedBaskets } from '../../../Providers/SavedBasketsProvider'

const useHandleAddToBasketBtn = (product, quantity) => {
    const { addProductToBasket, updateProductInBasket, deleteInCart } = useCart()
    const { savedOfferId, handleAddUpdateProductToSavedOffer, handleGetSavedOffer, setSelectedSavedOffer } = useOffers()
    const { selectedSavedBasket, setSelectedSavedBasket, deleteProductFromSavedBasket, addSingleProductToSavedBasket } = useSavedBaskets()

    const handleBtnOnClick = async (operation) => {
        const baseUnit = product && product.baseUnit ? product.baseUnit.toLowerCase() : product.baseUnit

        if (quantity <= 0 && operation === 'add') {
            return
        }
        if (savedOfferId == -1 && (selectedSavedBasket === null || selectedSavedBasket === undefined) && quantity == 0 && operation === 'update') {
            await deleteInCart(product)
            return
        }
        if (product.salesRatio && (quantity % product.salesRatio !== 0)) {
            toast.warning(`Niepoprawna ilość! Podana ilość musi być wielokrotnością pakietu sprzedażowego, który wynosi: ${product.salesRatio} ${baseUnit}`)
            return
        }
        if (savedOfferId != -1) {
            await handleAddUpdateProductToSavedOffer(product, quantity)
            const res = await handleGetSavedOffer(0, savedOfferId)
            setSelectedSavedOffer(res)
        }
        else if (selectedSavedBasket) {
            if (quantity == 0) {
                if (selectedSavedBasket.basketItems.length <= 1) {
                    toast.warning('Nie możesz usunąć wszystkich pozycji z szybkokoszyka!')
                    return
                }
                const res = await deleteProductFromSavedBasket(selectedSavedBasket.basketId, product.index)
                if (res) {
                    setSelectedSavedBasket(prevBasket => {
                        return {
                            ...prevBasket,
                            basketItems: prevBasket.basketItems.filter(
                                item => item.artNo !== product.index
                            )
                        }
                    })
                }
            }
            else {
                const res = await addSingleProductToSavedBasket(selectedSavedBasket.basketId, product.index, quantity)
                if (res) {
                    setSelectedSavedBasket(prev => {
                        const updatedItems = [...prev.basketItems]
                        const existingIndex = updatedItems.findIndex(item => item.artNo === product.index)

                        if (existingIndex !== -1) {
                            updatedItems[existingIndex] = {
                                ...updatedItems[existingIndex],
                                qty: quantity
                            }
                        } else {
                            updatedItems.push({
                                artNo: product.index,
                                qty: quantity,
                            });
                        }
                        return {
                            ...prev,
                            basketItems: updatedItems
                        }
                    })
                }
            }
            return
        }
        else {
            switch (operation) {
                case 'add':
                    await addProductToBasket(product.index, quantity)
                    break;
                case 'update':
                    await updateProductInBasket(product.index, quantity)
                    break
                default:
                    break
            }
        }
    }
    return { handleBtnOnClick }
}

export default useHandleAddToBasketBtn